var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"notification",staticClass:"notification-container",class:_vm.type,on:{"mouseenter":_vm.removeTimeout,"mouseleave":() => _vm.attachTimeout(3000),"click":() => _vm.$destroy()}},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }